import { motion } from "framer-motion";

const WORDS = ["Artisanal", "Handcrafted", "Premium", "Freezer-to-Plate", "Small-Batch", "For Service"];

export const Marquee = () => {
  const row = [...WORDS, ...WORDS];
  return (
    <section data-testid="marquee" className="border-y border-[#E6E2D8] bg-[#F5F2EB] py-6 md:py-8 overflow-hidden">
      <motion.div
        className="flex whitespace-nowrap"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ duration: 28, ease: "linear", repeat: Infinity }}
      >
        {row.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display italic text-4xl md:text-6xl text-[#2A221C] px-8">{w}</span>
            <span className="h-2 w-2 rounded-full bg-[#D4A373]" />
          </span>
        ))}
      </motion.div>
    </section>
  );
};
